import { useAppAbility } from "@/casl";
import { AppearancePanel, WidgetsPanel } from "@/components/organisms";
import { ClientTools } from "./Registration/ClientTools";

export const Marketing = () => {
  const ability = useAppAbility();

  return (
    <div className="flex flex-col items-start gap-5">
      <ClientTools />
      {ability.can("manage", "providerConfigBranding") && <AppearancePanel />}
      <WidgetsPanel />
    </div>
  );
};

Marketing.ClientTools = ClientTools;
